module.exports = __webpack_public_path__ + "static/img/repast01.4242b01e.jpg";